import { Text } from '@mantine/core';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultSystemAnnouncementResource,
    SystemAnnouncementMutationResourceSchema,
    useSystemAnnouncementActions,
} from '../../../../resource/resources/persistables/system/announcement/systemAnnouncementResource';
import { Form_EditableViewWrapper } from '../../../reusable-components/form-components/Form_EditableViewWrapper';
import { SystemAnnouncementContent } from '../../../reusable-components/resource-contents/SystemAnnouncementContent';
import { ResourceValidationTitleBar } from '../../../reusable-components/validation/ResourceValidationTitleBar';

export const SystemAnnouncementView = ({ id, readOnly }: { id: string | undefined; readOnly: boolean }) => {
    const systemAnnouncementActions = useSystemAnnouncementActions();

    const resourceQuery = systemAnnouncementActions.useGetResource(id);
    const updateResource = systemAnnouncementActions.useUpdateResource();
    const validateResource = systemAnnouncementActions.useValidateResource(id);

    const { form, formNames, onSubmit } = useMyForm({
        schema: SystemAnnouncementMutationResourceSchema,
        defaultValues: defaultSystemAnnouncementResource,
        submitHandler: async (data) => {
            await updateResource.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: resourceQuery.data,
    });

    return (
        <QueryBaseComponent name="System Announcement" query={resourceQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateResource.data}
                    resourceType={ResourceType.SYSTEM_ANNOUNCEMENT}
                >
                    <Text c={'dimmed'}>System Announcement</Text>
                </ResourceValidationTitleBar>
                <SystemAnnouncementContent id={id} form={form} formNames={formNames} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
